<template>
    <g>
        <path :style="{ fill: color }" d="M54.4,62.6c-1.4,0-2.8-0.2-2.6,0c0.3,0.2,1.1,0.6,2.6,0.6c1.4,0,2.3-0.4,2.6-0.6
		C57.3,62.3,55.8,62.6,54.4,62.6z"/>
        <path :style="{ fill: color }" d="M59.3,59.4c-1,0.1-2.1-0.1-3.1,0c-0.7,0-1.4,0.1-2.1,0.3c-0.7-0.2-1.4-0.2-2.1-0.3c-1,0-2.1,0.1-3,0
		c-0.6,0-0.8-0.3-0.8-0.3s0,0.2,0.1,0.3c0.8,0.5,1.9,0.7,3,0.9c1,0.1,1.9,0.2,2.9,0.3c0,0,0.1,0,0.1,0c1-0.1,1.9-0.2,2.9-0.3
		c1-0.1,2.2-0.3,3-0.9c0.1-0.1,0.1-0.3,0.1-0.3S59.9,59.4,59.3,59.4z"/>
    </g>
</template>

<script>
    import Mouth from './Mouth';

    export default {
        name: 'Mouth11',
        mixins: [Mouth],
    }
</script>
